import { MobXProviderContext, observer } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import { useConversationStore } from 'Modules/conversation/store/index.store';
import React, { useContext } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { mapContactCategory } from '../../../../../utils/map_contact_category';
import { EntityContactCard } from '../../../../EntityContactCard';
import { GroupMemberCardProps } from './index.types';

export const GroupMemberCard = observer(
  ({ contact, openContactDetails, phoneNumber }: GroupMemberCardProps) => {
    const { person: personStore, ui: uiStore } = useContext(
      MobXProviderContext
    ) as RootStoreProps;

    // Subscribe so the label updates when opt-out status changes in real time.
    const isOptedOut = useConversationStore(
      (state) =>
        !!phoneNumber && state.getOptOutPhoneNumberInfo(phoneNumber) === true
    );

    const category = () => {
      if (
        contact instanceof ContactModelV2 &&
        contact.sourceId === personStore.loggedInPersonId.toString()
      ) {
        return 'You';
      }

      return mapContactCategory(contact);
    };

    // Calculate presence directly from MobX store instead of using useState
    // This ensures the component re-renders when presence changes
    const presence =
      contact instanceof ContactModelV2 && contact.sourceId
        ? uiStore.selectPersonPresenceStatus(contact.sourceId)
        : null;

    const subTitle = isOptedOut ? 'Opted-out' : category();

    if (contact instanceof ContactModelV2) {
      return (
        <EntityContactCard
          image={contact.avatarUrl}
          name={contact.name}
          subTitle={subTitle}
          isDestructiveSubtitle={isOptedOut}
          presence={presence}
          hasContact
          isInactive={contact.deleted}
          onNavigateToContact={() => openContactDetails(contact)}
        />
      );
    }

    return (
      <EntityContactCard
        name={contact.FormattedPhone}
        subTitle={subTitle}
        isDestructiveSubtitle={isOptedOut}
        hasContact
        onNavigateToContact={() => openContactDetails(contact)}
        isUnsaved
      />
    );
  }
);
